<template>
  <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2">
    <rect x="4" y="8" width="40" height="32" rx="4"/>
    <path d="M4 16h40"/>
    <circle cx="10" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="15" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <circle cx="20" cy="12" r="1.5" fill="currentColor" stroke="none"/>
    <path d="M16 28h16M20 33h8" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "IconBrowser",
  props: {
    size: { type: [Number, String], default: 48 },
  },
};
</script>
